import React from 'react';
import Grouped from './Grouped';

const NestedGroup = ({ data, groupedBy, level }) => {
  return <Grouped data={data} groupedBy={groupedBy} level={level} />;
};

export default NestedGroup;
